import React, { useEffect, useState, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import images from '../../images/images';

import './TopologyEmptyState.scss';
import { NetworkSegment, TopologyEmptyStateModel } from '../../models/master';
import { Button } from '@carbon/react';
import { getNetworkSegments } from '../../controllers/networksegmentsApi';
import { Add } from '@carbon/react/icons';
import { useLocation } from 'react-router-dom';
import { SkeletonText } from '@carbon/react';
import { SkeletonPlaceholder } from '@carbon/react';

interface Props {
  emptyStateObject: TopologyEmptyStateModel;
  header?: string;
  description?: string;
  selectedNetworkSegment: NetworkSegment | null;
}

const TopologyEmptyState: React.FC<Props> = ({
  header,
  description,
  emptyStateObject,
}) => {
  return (
    <div className='topology-empty-page'>
      <div className='empty-image'>{images.NoTopologyDataSvg()}</div>
      <div className='dataset'>
        <div className=''>
          <>
            <div className='header'>{header}</div>
            <div className='description'>{description}</div>
            {emptyStateObject?.buttonText !== undefined &&
            emptyStateObject?.buttonText?.length > 1 ? (
              <Button
                onClick={emptyStateObject?.onClick}
                className='button'
                kind='tertiary'
                renderIcon={() => <Add size={16} />}
              >
                {emptyStateObject?.buttonText}
              </Button>
            ) : (
              <></>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default TopologyEmptyState;
